import { onBeforeMount, ref, computed } from "vue";
import { useStore } from "vuex";

export default function useAddNewCourse() {
  const store = useStore();
  const name = ref();
  const regionSlug = ref();
  const contract_devices = ref(0);
  const type = ref();
  const product_type = ref();
  const loading = computed(() => store.getters["courses/isLoading"]);

  const typeList = ref([
    {
      name: "PRIVATE",
      slug: "private",
    },
    {
      name: "RESORT",
      slug: "resort",
    },
    {
      name: "DAILY FEE",
      slug: "daily_fee",
    },
    {
      name: "TEST",
      slug: "test",
    },
  ]);

  const productsList = computed(
    () => store.getters["packages/getPackagesList"]
  );

  const regionsList = computed(() => store.getters["regions/getRegionsList"]);
  const isFormValid = computed(
    () => !!regionSlug.value && !!type.value && !!product_type.value
  );

  const fetchPackages = () => store.dispatch("packages/fetchPackages");

  onBeforeMount(async () => {
    // Make api call to get regions
    store.dispatch("regions/fetchRegions");
    fetchPackages();
  });

  const save = async () => {
    const payload = {
      name: name.value,
      region: regionSlug.value.slug,
      contract_devices: contract_devices.value,
      type: type.value.slug,
      package_id: product_type.value?.id,
    };
    try {
      await store.dispatch("courses/saveCourse", payload);
      store.dispatch("toastNotification/displayToast", {
        message: "Course created successfully",
        type: "success",
      });
    } catch (error) {
      store.dispatch("toastNotification/displayToast", {
        message: error || "Save Course failed",
        type: "error",
      });
    }
  };

  return {
    name,
    regionSlug,
    contract_devices,
    type,
    product_type,
    loading,
    typeList,
    productsList,
    regionsList,
    isFormValid,
    fetchPackages,
    save,
  };
}
